import styles from "./MainHeader.module.scss"
import {Heading, Tag, Button, Popover} from "@netapp/bxp-design-system-react";
import AccountMenu from "./AccountMenu"
import UserMenu from "./UserMenu"
import {Link} from "react-router-dom"
import {ReactComponent as MainLogo} from "./images/NewMainLogo.svg";
import {ReactComponent as ConsoleIcon} from "./images/NewConsoleIcon.svg";
import { MenuIcon } from "@netapp/bxp-style/react-icons/Navigation"
import {css} from '@emotion/react';
import {useSelector} from "react-redux";
import {RootState} from "../../../store";
import {useConsole} from "../../console/consoleStore";
import AccountMenuDataTest from "../../../testUtils/accountMenuDataTest.ts";
import {useState} from "react";
import MainNav from "modules/app/components/MainNav.tsx";
import navDataTest from "testUtils/navDataTest.ts";

const productNameCss = css`
    display: flex;
    align-items: center;
    padding-left: 18px;
`;

const leftNavHamburgerCss = (isNavOpen: boolean) => css`
    cursor: pointer;
    width: 72px;
    height: 72px;
    background-color: var(${isNavOpen ? "--background-hover" : "--background-content"});
    box-shadow: 0px -1px 0px 0px var(--border-drop-shadow) inset;
    position: relative;
    justify-content: center;
    align-items: center;

    svg {
        --icon-primary: var(--icon-secondary);
    }
    &:disabled {
        svg {
            --icon-primary: var(--text-primary);
            opacity: 0.5;
        }
        background-color: var(--button-primary-bg-disabled);
    }

    &:hover:not(:disabled) {
        background-color: var(--shell-main-nav-bg-hover-v2);
    }

    &:focus-visible {
        border: 2px solid var(--border-focus-outline);
        outline: none !important;
    }
`


const Widgets = ({isFirstTimeUser}: { isFirstTimeUser: boolean }) => {
    const setIsConsoleOpen = useConsole((state) => state.setIsConsoleOpen);
    return <div className={styles.widgets}>
        {!isFirstTimeUser && <>
            <Popover Trigger={() => {
                return <Button className={styles.widgetButtonNewNav} onClick={() => {
                    setIsConsoleOpen(true);
                }} variant="icon" color="secondary" dataTestId={AccountMenuDataTest.cloudShell.cloudShellButtonGlobal}><ConsoleIcon style={{width:25, height: 21}}/></Button>
            }}>
                <span>CloudShell</span>
            </Popover>
            <AccountMenu/>
        </>}
        <UserMenu/>
    </div>
}


const MainHeader = ({isFirstTimeUser}: { isFirstTimeUser: boolean }) => {
    const isDemo = useSelector((state: RootState) => state.tenancy.isDemo);
    const [isNavOpen, setIsNavOpen] = useState<boolean>(false)


    return <div className={styles.base} style={{paddingLeft: 0}}>
        <Button dataTestId={navDataTest.hamburgerNav} css={leftNavHamburgerCss(isNavOpen)} variant={"icon"} onClick={()=>{setIsNavOpen(prev => !prev)}}><MenuIcon size={24}/></Button>
        <MainNav isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen}/>
        <div css={productNameCss}>
            <Link to="/" css={productNameCss}>
                <MainLogo style={{marginRight: 16}}/>
                <Heading level="16" bold style={{marginRight: 16}}>Workload Factory</Heading>
            </Link>
            {isDemo && <Tag color="chart-1">Demo</Tag>}
        </div>

        <Widgets isFirstTimeUser={isFirstTimeUser}/>
    </div>
}

export default MainHeader;
